import axios from "axios";
import { BASE_URL2 } from "../types/constant";
import { getOngOngBaseError, getOngOngBaseResponse } from "./ong-base-response";

export const ongBaseApi = axios.create({
  baseURL: BASE_URL2,
  headers: {
    "Content-Type": "application/json",
  },
});

ongBaseApi.interceptors.response.use(getOngOngBaseResponse, getOngOngBaseError);
